import { render, staticRenderFns } from "./BodyDeAditivos.vue?vue&type=template&id=a7d48bc8&scoped=true"
import script from "./BodyDeAditivos.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyDeAditivos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BodyDeAditivos.vue?vue&type=style&index=0&id=a7d48bc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d48bc8",
  null
  
)

export default component.exports